import { empApi } from "./client";

// =============================================================
// API Quản lý nhân viên (staff) - FEv1 cổng nhân viên.
// Danh sách nhân viên cấp dưới theo vai trò (kinh doanh / hỗ trợ kinh doanh).
// Phạm vi do BE lọc theo token.
// =============================================================

// Danh sách nhân viên cấp dưới - khối kinh doanh -> { items, pagination }
export const getBusinessStaffListApi = (params) =>
  empApi.get("/employee/app/business/listEmployeeSubordinates", params);

// Danh sách nhân viên cấp dưới - khối hỗ trợ kinh doanh -> { items, pagination }
export const getSupportBusinessStaffListApi = (params) =>
  empApi.get("/employee/app/spBusiness/listEmployeeSubordinates", params);

// Thông tin chi tiết 1 nhân viên (góc nhìn quản lý)
export const getStaffEmployeeInfoApi = (id) =>
  empApi.get(`/employee/app/manager/info/${id}`);
